var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 48.682,
    viewBox: "0 0 51 48.682",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M43.767,38.181a10.589,10.589,0,1,0-3.292,3.269l7.233,7.233L51,45.39Zm-8.809.255a5.8,5.8,0,1,1,5.8-5.8A5.8,5.8,0,0,1,34.958,38.436Zm-.835-19.7a13.649,13.649,0,0,0-4.868,1.043L27.98,17.85,19.171,32.176l-6.978-8.16L3.779,37.485,0,34.773,11.591,16.227l6.955,8.114L27.818,9.273Zm6,1.159a13.729,13.729,0,0,0-4.752-1.136L47.244,0,51,2.735Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScore);
export default __webpack_public_path__ + "static/media/score.612106ab55642720b93cb8b65212b625.svg";
export { ForwardRef as ReactComponent };